<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <th v-for="column in columns" :key="column.id">{{column}}</th>
      </slot>
    </thead>
    <tbody>
    <tr v-for="item in data" :key="item">
      <slot :row="item">
          <td v-for="column in columnsFiltered" :key="column.id"><span v-if="hasValue(item, column)">{{itemValue(item, column)}}</span></td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'l-table',
    props: {
      columns: Array,
      data: Array
    },
    methods: {
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      }
    }
  }
</script>
<style>
</style>
